/**
 * Builds a new instance of the StoryStreamEmbed component.
 * @module StoryStreamEmbed
 * @constructor
 */

/** @lends module:StoryStreamEmbed */
function StoryStreamEmbed (scope, util, element, params) {
    var that = this;
    that.attribute = 'data-stry-embed';

    /*  Catch instantiation errors  */
    if (!scope && !util && !element && !params) { return; }  //  Registration condition
    else {
        if (!scope) { console.error('StoryStream -> StoryStreamEmbed -> No scope provided.'); return; }
        if (!util) { console.error('StoryStream -> StoryStreamEmbed -> No util available.'); return; }
        if (!element) { console.error('StoryStream -> StoryStreamEmbed -> No element available.'); return; }
        if (!params) { console.error('StoryStream -> StoryStreamEmbed -> No params provided.'); return; }
    }
    /*  End  */

    that.elem = element;
    that.embed_instance = undefined;
    that.uid = params.uid;


    /**
     * Funnel all events through this method and distribute.
     * @memberof Body
     * @function handleEvent
     * @param {object} e - Event data.
     * @inner
     */
    var handleEvent = function(e) {
        var type = e.type ? e.type : e.name;
        switch(type) {
            case 'documentIsReady':
            case 'documentHasUpdated':

                whenAppHasRendered();

                break;
            case 'onItemLoadingComplete':

                whenExpandedItemLoaded();

                break;
        }
    };


    /**
     * Function to reposition share overlay when items are added to the document
     * @memberof StoryStreamEmbed
     * @function whenAppHasRendered
     * @inner
     */
    var whenAppHasRendered = function () {
        var items = that.embed_instance.el.getElementsByClassName('stry-item');
        var valid_items = [];
        var len = items.length;
        var text;
        var social_overlay;

        //  Find all content item elements
        while (len--) {

            //  Filter out items that are not Tweets
            if (!util.hasClass(items[len], 'twitter')) {
                valid_items.push(items[len]);
            }
        }

        //  Now loop through valid content items and reposition share overlay
        len = valid_items.length;
        while (len--) {

            //  Find elements
            text = valid_items[len].getElementsByClassName('stry-text')[0];
            social_overlay = valid_items[len].getElementsByClassName('stry-share-overlay')[0];

            //  Move social element if both target and subject exist
            if (text && social_overlay) {
                text.appendChild(social_overlay);
            }
        }
    };


    /**
     * Function to handle ensuring the expanded item has rendered before proceeding
     * @memberof StoryStreamEmbed
     * @function whenExpandedItemLoaded
     * @inner
     */
    var whenExpandedItemLoaded = function () {
        var ready = setInterval(function () {
            var expanded_elem = that.elem.querySelector('.stry-popup');
            var has_content = expanded_elem && expanded_elem.innerHTML ? true : false;

            //  Once rendered
            if (has_content) {

                //  Proceed to affect rendered element
                whenExpandedItemRendered(expanded_elem);

                //  Prevent further attempts at checking for content
                clearInterval(ready);
            }
        }, 5);
    };


    /**
     * Function to reposition share overlay when items are expanded
     * @memberof StoryStreamEmbed
     * @function whenExpandedItemRendered
     * @param {object} target - DOM element to apply actions to.
     * @inner
     */
    var whenExpandedItemRendered = function (target) {
        var item = target.getElementsByClassName('stry-popup-outer')[0];
        var social_overlay;
        var text;

        //  Repositon share elemnts if this is not a tweet
        if (!util.hasClass(item, 'twitter')) {

            //  Find elements
            text = item.getElementsByClassName('stry-text')[0];
            social_overlay = item.getElementsByClassName('stry-share-overlay')[0];

            //  Move social element if both target and subject exist
            if (text && social_overlay) {
                text.appendChild(social_overlay);
            }
        }
    };


    /**
     * Function used to initialise the application.
     * @memberof StoryStreamEmbed
     * @function init
     * @inner
     */
    var init = function () {
        var script = that.elem.getElementsByTagName('script')[0].src;
        var file_name = script.split('/');
        var file_id = file_name[file_name.length - 1].replace('.js', '');
        var item;
        var instance_id;

        //  Find Storyboard app on this page
        for (item in STRY) {
            instance_id = item.replace('hub_', '').replace('widget_', '');

            if (file_id.indexOf(instance_id) > -1) {

                that.embed_instance = STRY[item];
            }
        }

        /*
         *  Add event listeners
         */
         if (that.embed_instance && that.embed_instance.el.id === 'CaseStudiesHub') {

             console.log('HELO');

            that.embed_instance.addEventListener("documentIsReady", handleEvent);
            that.embed_instance.addEventListener("documentHasUpdated", handleEvent);
            that.embed_instance.addEventListener("popupHasOpened", handleEvent);
            that.embed_instance.addEventListener("onItemLoadingComplete", handleEvent);
        }
    };

    init();
    return that;
}
if (typeof module !== 'undefined' && exports !== null) {
    exports.StoryStreamEmbed = StoryStreamEmbed;
}
